import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import { 
  KeyboardArrowDown, 
  BarChart, 
  Facebook, 
  Twitter 
} from '@mui/icons-material';
import { logout } from "../../modules/user/api/actions";
import MyAccountDrawer from "../../modules/settings/components/MyAccountDrawer";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom"
import {
  Avatar,
  Box,
  Badge,
  Menu,
  Button,
  List,
  ListItem,
  Tooltip,
  Divider
} from '@mui/material';

import avatar4 from '../../assets/images/avatars/avatar4.jpg';
import { withStyles } from '@mui/styles';

const StyledBadge = withStyles({
  badge: {
    backgroundColor: 'var(--success)',
    color: 'var(--success)',
    boxShadow: '0 0 0 2px #fff',
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    },
    avatar: {
      borderStyle: "solid",
      marginRight: "1em",
    },
  }
})(Badge);
function HeaderUserbox(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [accountOpen, setAccountOpen] = React.useState(false);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    props.logout();
    navigate("/");
  };

  const openAccount = () => {
    setAnchorEl(null);
    setAccountOpen(true);
  };

  return (
    <Fragment>
      <Button
        color="inherit"
        onClick={handleClick}
        className="text-capitalize px-3 text-left btn-inverse d-flex align-items-center">
        <Box>
          <StyledBadge
            overlap="circle"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            variant="dot">
            <Avatar className={StyledBadge.avatar}>
              {props.user.details
                ? `${props.user.details.firstName[0]}${props.user.details.lastName[0]}`
                : ""}
            </Avatar>          </StyledBadge>
        </Box>
        <div className="d-none d-xl-block pl-3">
          <div className="font-weight-bold pt-2 line-height-1">
            {`${props.user.details.firstName} ${props.user.details.lastName}`}
          </div>
          {props.user.details.isSuperUser ? (
            <span className="text-danger text-center">
              ADMIN
            </span>) : (<span className="text-white-50 text-center">
              Internal User
            </span>)}
        </div>
        <span className="pl-1 pl-xl-3">
          <KeyboardArrowDown className="opacity-5" />
        </span>
      </Button>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center'
        }}
        onClose={handleClose}
        className="ml-2">
        <div className="dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
          <List className="text-left bg-transparent d-flex align-items-center flex-column pt-0">
            <Box>
              <StyledBadge
                overlap="circle"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                variant="dot">
                <Avatar className={StyledBadge.avatar}>
                  {props.user.details
                    ? `${props.user.details.firstName[0]} ${props.user.details.lastName[0]}`
                    : ""}
                </Avatar>              </StyledBadge>
            </Box>
            <div className="pl-3 ">
              <div className="font-weight-bold text-center pt-2 line-height-1">
                {`${props.user.details.firstName} ${props.user.details.lastName}`}
              </div>

              {props.user.details.isSuperUser ? (
                <span className="text-danger text-center">
                  ADMIN
                </span>) : (<span className="text-black-50 text-center">
                  Internal User
                </span>)}

            </div>
            <Divider className="w-100 mt-2" />
            <ListItem button onClick={logout}>Logout</ListItem>
            <ListItem button onClick={openAccount}>My account</ListItem>
            <Divider className="w-100" />
            {/* <ListItem className="p-0">
              <div className="grid-menu grid-menu-2col w-100">
                <div className="py-3">
                  <div className="d-flex justify-content-center">
                    <div className="d-flex align-items-center">
                      <div>
                        <BarChart sx={{ fontSize: '4rem', color: '#17a2b8' }} />
                      </div>
                      <div className="pl-3 line-height-sm">
                        <b className="font-size-lg">$9,693</b>
                        <span className="text-black-50 d-block">revenue</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ListItem> */}
            <Divider className="w-100" />
            {/* <ListItem className="d-block rounded-bottom px-3 pt-3 pb-0 text-center">
              <Tooltip arrow title="Facebook">
                <Button color="default" className="text-facebook">
                  <span className="btn-wrapper--icon">
                    <Facebook />
                  </span>
                </Button>
              </Tooltip>
              <Tooltip arrow title="Dribbble">
                <Button color="default" className="text-dribbble mr-2 ml-2">
                  <span className="btn-wrapper--icon">
                    <BarChart />
                  </span>
                </Button>
              </Tooltip>
              <Tooltip arrow title="Twitter">
                <Button color="default" className="text-twitter">
                  <span className="btn-wrapper--icon">
                    <Twitter />
                  </span>
                </Button>
              </Tooltip>
            </ListItem> */}
          </List>
        </div>
      </Menu>
      <MyAccountDrawer open={accountOpen} onClose={() => setAccountOpen(false)} />
    </Fragment>
  );
}

HeaderUserbox.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
};

function HeaderUserboxState(state) {
  return {
    user: state.user,
    apl: state.apl,
  };
}

export default connect(HeaderUserboxState, {
  logout
})(HeaderUserbox);